import React from 'react'
import { useSelector } from 'react-redux'
import { cookiesKeyNames } from '@revbox/common-fe'
import { useCookiesContext } from '../contexts/CookiesContext'
import { useRoles } from '../hooks/useRoles'
import NotificationsDropdown from '../components/header/NotificationsDropdown'
import SkinDropdown from '../components/header/SkinDropdown'
import UserProfileDropdown from '../components/header/UserProfileDropdown'
import Tour from '../components/header/Tour'

export default function Header() {
    const user = useSelector(state => state.user)
    const { userAccesses } = useRoles(user.role)
    const { getAdvertiserId, getPublisherId, getIsTourCompleted } = useCookiesContext()
    const advertiserId = getAdvertiserId()
    const publisherId = getPublisherId()
    const tourCompleted = getIsTourCompleted(cookiesKeyNames.tourAdvInit)
    const triggerBtnCondition = advertiserId && publisherId && ![67, 10, '67', '10'].includes(publisherId) && tourCompleted

    const toggleSidebar = e => {
        e.preventDefault()
        let isOffset = document.body.classList.contains('sidebar-offset')
        if (isOffset) {
            document.body.classList.toggle('sidebar-show')
        } else {
            if (window.matchMedia('(max-width: 991px)').matches) {
                document.body.classList.toggle('sidebar-show')
            } else {
                document.body.classList.toggle('sidebar-hide')
            }
        }
    }

    const isCustomUser = user.role === 'CUSTOMER'

    return (
        <div className="header-main px-3 px-lg-4">
            <button onClick={toggleSidebar} className="menu-link me-3 me-lg-4">
                <i className="ri-menu-2-fill"></i>
            </button>

            <div className="me-auto"></div>

            {triggerBtnCondition && <Tour />}

            <SkinDropdown user={user} userAccesses={userAccesses} />

            {isCustomUser ? <></> : <NotificationsDropdown advertiserId={advertiserId} />}

            <UserProfileDropdown user={user} userAccesses={userAccesses} advertiserId={advertiserId} />
        </div>
    )
}
